import { ref } from 'vue';
import type { GenericField } from '@Types';
import type { FieldInitialSettings, FieldSchema, RawField } from '@FormModule';
import { getWeightDateTimestamp } from '@Helpers';
import { useSessionStore } from '@Stores';
import { useForm } from '@FormModule';

const currentSchemaModels = ref<Set<GenericField>>(new Set());
const fieldsSchema = ref<FieldSchema[]>([]);
const formError = ref();

export default function () {
  const { shelterProfile } = useSessionStore();
  const weightUnit = shelterProfile?.value?.weight_unit ?? 'lbs';
  const dateFormat = shelterProfile?.value?.date_format ?? 'mm/dd/yy';

  const { getDetailsSchema } = useForm();

  const fieldsSettings: FieldInitialSettings = {
    unit: {
      edit: {
        options: ['lbs', 'oz', 'kg', 'g'],
      },
      model: weightUnit,
    },
    date: {
      settings: {
        maxDate: new Date(),
        showTime: true,
        dateFormat: dateFormat,
        hourFormat: '12',
      },
    },
    weight: {
      settings: {
        minFractionDigits: 2,
        maxFractionDigits: 3,
      },
    },
  };
  const rawFields: RawField[] = [
    {
      label: 'Weight Date',
      name: 'date',
      required: true,
      type: 'date',
      value: '',
    },
    {
      label: 'Weight',
      name: 'weight',
      required: true,
      type: 'number',
      value: '',
    },
    {
      label: 'Unit of measurement',
      name: 'unit',
      required: true,
      type: 'select',
      value: '',
    },
  ];

  function setForm() {
    if (fieldsSchema.value.length) return;

    fieldsSchema.value = getDetailsSchema(rawFields, fieldsSettings);
  }

  function updateSchemaModels(sourceData: any) {
    setForm();

    fieldsSchema.value.forEach((field) => {
      const match = sourceData[field.name];
      if (!match) return;

      switch (field.name) {
        case 'date': {
          const timestamp = getWeightDateTimestamp(sourceData);
          field.model = timestamp ? new Date(timestamp) : '';
          field.value = field.model;
          break;
        }
        case 'weight': {
          field.model = Number(sourceData.weight);
          field.value = Number(sourceData.weight);
          break;
        }
        default: {
          field.model = match;
          field.value = match;
        }
      }
    });
  }

  function resetFieldSchema() {
    currentSchemaModels.value = new Set();
    fieldsSchema.value = [];
    formError.value = null;
  }

  return {
    currentSchemaModels,
    fieldsSchema,
    fieldsSettings,
    formError,
    setForm,
    resetFieldSchema,
    updateSchemaModels,
  };
}
